<template>
	<div class="returnpassword">
		<div class="top">
			<img class="logo" src="../../static/img/logo.png" />
			<h5 class="top_tit"><span>|</span> 会员管理系统</h5>
			<router-link class="back"  to="/login">
				返回登录
			</router-link>
		</div>
		<div class="con">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm ">
			    <h3 class="title"><span></span><strong>找回密码</strong></h3>	
			    <div class="middle">
			    	<div class="iptbox">
			    		<span>注册邮箱</span>
			    		<el-form-item style="width: 300px;height: 40px;float: right;margin-bottom: 0;"
						    prop="email"
						    :rules="[
						      { required: true, message: '请输入填写注册所用邮箱', trigger: 'blur' },
						      { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
						    ]"
						>						
						    <el-input class="email" v-model="ruleForm.email" placeholder="填写注册所用邮箱" clearable></el-input>
						</el-form-item>
			    	</div>
				    
				    
			    	 <!--验证码-->
				    <div class="iptbox">
				    	<span>验证码</span>	
				    	<el-form-item style="width:158px;height: 40px;float: left;margin:0 0 0 5px;"  prop="code">	    	
					      	<el-input class="user" type="text" v-model="ruleForm.code" auto-complete="off" placeholder="请输入请输入验证码" clearable></el-input>
					    </el-form-item>
					    <el-form-item style="width:125px;float: right;">
					      	<el-button  type="primary" style="width:100%;" @click="get_code" >获取验证码</el-button>
					    </el-form-item>
				    </div>
				    
				    <div class="iptbox">
				    	<span>输入新密码</span>	
				    	<el-form-item style="width: 300px;height: 40px;float: right;margin-bottom: 0;"  prop="new">	    	
					      	<el-input  type="text" v-model="ruleForm.new"  placeholder="输入新密码" clearable></el-input>
					    </el-form-item>
				    </div>
				    
			    	 <!--验证码-->
				    <div class="iptbox">
				    	<span>再输入一次</span>	
				    	<el-form-item style="width: 300px;height: 40px;float: right;margin-bottom: 0;"  prop="check_new">	    	
					      	<el-input  type="text" v-model="ruleForm.check_new"  placeholder="再次确认密码" clearable></el-input>
					    </el-form-item>
				    </div>
				    
				    
				    <el-form-item style="width: 160px;display: block;margin-left: 100px;">
				      	<el-button class="btn" type="primary" style="width:100%;" @click.native.prevent="onSubmit" >找回密码</el-button>
				    </el-form-item>
				    <!--<router-link style="display:block;text-align: left;text-indent: 100px;color: #0076FF;"  to="/returnPassword">
						通过其他方式找回密码
					</router-link>-->
					<a style="display:block;text-align: left;text-indent: 100px;color: #0076FF;">如有其他登录问题请联系中国质量协会</a>
			    </div>
			</el-form>
		</div>
		<bottom></bottom>
	</div>
</template>

<script>
	import Qs from 'qs'
	import bottom from './Bottom'
  	export default {
  		components: {
			bottom
		},
	    data() {
	    	var validatePass = (rule, value, callback) => {
		        if (value === '') {
		          callback(new Error('请输入密码'));
		        } else {
		          if (this.ruleForm.checkPass !== '') {
		            this.$refs.ruleForm.validateField('checkPass');
		          }
		          callback();
		        }
	      	};
		    return {
		        ruleForm: {
		        	code:'',
			        email:'',
			        new:'',
			        check_new:'',
		        },
		        rules: {
		        	code: [
			            { required: true, message: '请输入验证码', trigger: 'blur' },
			        ],
			        new: [
			            { validator: validatePass, trigger: 'blur' },
			            { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/, message: '最少6位数字+字母密码' }
			        ],
			        check_new: [
			            { required: true, message: '再次确认密码', trigger: 'blur' },
			        ]
		        }
		    };
	    },
		created() {
	  	},
	  	mounted() {
		   
		},
	    methods: {
	    	get_code(){
	    		console.log(this.ruleForm.email);
	    		if(!this.ruleForm.email){
	    			this.$toast('请填写注册所用邮箱');	
	    			return false;
	    		};
	    		var data = {
	    			'email':this.ruleForm.email
	    		};
	    		this.$axios({
					method: 'post',
					url: 'user/mail',
					data: Qs.stringify(data)
				}).then(response => {
					console.log(response.data)
					this.$toast(response.data.msg);										
				});		    		
	    	},
		    onSubmit(ev) {		    			    	
		        this.$refs.ruleForm.validate((valid) => {
		        	if (valid) {
		        		if(this.ruleForm.new !=this.ruleForm.check_new){
		        			this.$toast('密码两次输入不一致！');
		        			return false;
		        		};
		        		var data = {
			    			'email':this.ruleForm.email,
			    			'captcha':this.ruleForm.code,
			    			'password':this.ruleForm.new,
		        			'repassword':this.ruleForm.check_new,
			    		};
			    		var that = this;
		        		this.$axios({
							method: 'post',
							url: 'user/retrieve',
							data: Qs.stringify(data)
						}).then(response => {
							if(response.data.status==4){
								localStorage.removeItem('sessionid');
								this.$toast(response.data.msg); 
								setTimeout(function(){
								 	that.$router.push('/login');
								},2500);
					        }else{
					            this.$toast(response.data.msg);
					        }							
						});	
			            
			       }else{
//			       		this.$alert('密码找回申请，审核需7个工作日，审核成功后，请前往邮箱查看', '提交成功', {
//				          	confirmButtonText: '确定',
//				          	showClose:false,
//				          	type: 'success',
//				          	callback: action => {
//				            	
//				         	}
//				        });
			       	}		        	
		       });	
		    },
	    }
	}

</script>
<style scoped >
.returnpassword{
	width: 100%;
	height: auto;
	background: #fff;
	font-family:PingFangSC-Medium;
	font-size:20px;
	color:rgba(0,0,0,0.45);
}
.top{
	height:80px ;
	position: relative;
}
.logo{
	width: 211px;
	height: 43px;
	position: absolute;
	top: 16px;
	left: 254px;
}
.top_tit{
	position: absolute;
	top: 26px;
	left: 480px;
	height:28px;
	font-weight:bold;
	color:rgba(0,94,179,1);
	line-height:28px;
}
.top_tit span{
	height:17px;
	color: #E8E8E8;
}
.back{
	position: absolute;
	top: 30px;
	right: 249px;
	font-size:14px;
	font-weight:bold;
	color:rgba(128,128,128,1);
	line-height:20px;
}
.con{
	position: relative;
	border-top: 1px solid rgba(0,0,0,0);
	box-sizing: border-box;
	width: 100%;
	height: 600px;
	background:rgba(246,248,249,1);
	font-size: 14px;
}

.demo-ruleForm{
	width: 800px;
	height: 518px;
	background: #fff;
	margin: 39px auto 0;
}
.title{
	text-align: left;
	text-indent: 15px;
	height: 54px;
	vertical-align: middle;
	line-height: 54px;
	/*border-bottom: 2px solid #EEEEEE;*/
	background: #0076FF;
}
/*.title span{
	display: inline-block;
	width:8px;
	height:20px;
	background:rgba(0,94,178,1);	
	margin:0 11px 0 13px;   
	vertical-align: middle; 
}*/
.title strong{
	display: inline-block;
	font-size:20px;
	line-height: 28px;
	font-weight:bold;
	color:#fff;
	/*color:rgba(0,94,178,1);*/
	vertical-align: middle;
}
.middle{
	width: 400px;
	height: auto;
	margin:75px auto 0;
}
.iptbox{
	width: 100%;
	height: 40px;
	position: relative;
	margin-bottom: 20px;		
}
.iptbox span{
	float: left;
	line-height: 40px;
	width:86px;
	height:40px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(100,100,100,1);
	text-align: right;
	margin-right: 10px;
}
.btn{
	width:160px;
	height:48px;
	background:#0076FF;
	border-radius:4px;
	border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ReturnPassword1.vue